import { getSubscriptionData } from 'src/redux-api-bridge'
import store from 'src/store'

/**
 * Reloads the subscription data using Redux
 * This provides a more elegant alternative to window.location.reload()
 *
 * @returns Promise that resolves when subscription data is loaded
 */
export function reloadSubscriptionData(): Promise<void> {
  return new Promise<void>(resolve => {
    // Dispatch the action to reload subscription data
    getSubscriptionData(store.dispatch)
      .then(() => {
        resolve()
      })
      .catch(error => {
        console.error('Error reloading subscription data:', error)
        resolve() // Resolve anyway to continue the flow
      })
  })
}
